import React from 'react';
import * as S from './style';
import { FormStatusInfo, Label, Btn } from 'components';
import { ReactComponent as ImgPartnerCreated } from 'assets/img/status/img_partner_created.svg';

import * as PAGE_URL from 'router/PageUrl';

function Created(): React.ReactElement {
    return (
        <FormStatusInfo
            title={['환영합니다!']}
            subTitle={['회원가입이 완료되었습니다.']}
            image={<ImgPartnerCreated />}
            btn={
                <Btn height={64} fontStyle={'body1_bold'} backGroundColor={'blue_900'} color={'gray_opacity_50'} href={PAGE_URL.LOGIN.path}>
                    {'로그인하러 가기'}
                </Btn>
            }
            inHomeBtn={true}
        >
            <S.CaptionWrapper>
                <Label contents={'로그인 후 서비스를 등록해주세요.'} color={'gray_opacity_600'} fontStyle={'body2'} />
            </S.CaptionWrapper>
        </FormStatusInfo>
    );
}

export default Created;
